import logoImg from "images/logo.png";

type Item = { name: string; price: string; note?: string };
type Section = { title: string; items: Item[] };

const SECTIONS: Section[] = [
  {
    title: "Aguas y refrescos",
    items: [
      { name: "Agua 50cl", price: "1,00€" },
      { name: "Refrescos", price: "2,50€", note: "Coca-Cola/Zero, Fanta/Schweppes naranja o limón, Aquarius, Nestea, Seven Up, Tónica" },
      { name: "Zumo de piña / naranja", price: "2,50€" },
      { name: "Guaraná", price: "2,50€" },
      { name: "Vichy Catalán", price: "2,50€" },
      { name: "Red Bull", price: "3,00€" },
    ],
  },
  {
    title: "Cervezas",
    items: [
      { name: "Estrella de Galicia", price: "3,00€" },
      { name: "Cerveza sin gluten", price: "3,00€" },
      { name: "Cerveza sin alcohol", price: "2,50€" },
      { name: "Coronita", price: "3,00€" },
    ],
  },
  {
    title: "Licores y combinados",
    items: [
      { name: "Licor solo 50ml", price: "desde 3,50€", note: "Ron, vodka, Malibu, Puerto de Indias, ginebra, Licor 43, whisky, Jäger" },
      { name: "Combinado con refresco", price: "6,00€" },
      { name: "Combinado + zumo", price: "6,00€" },
      { name: "Combinado + Red Bull", price: "6,50€" },
    ],
  },
  {
    title: "Vinos y cava",
    items: [
      { name: "Vino blanco Ramón Bilbao 75cl", price: "17,00€" },
      { name: "Vino tinto Ramón Bilbao 75cl", price: "17,00€" },
      { name: "Botella de cava", price: "25,00€" },
    ],
  },
];

const CartaBebidas = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-[#0c0a16] to-[#15101f] px-4 py-14">
      {/* glow de fondo */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-0 h-80 w-80 -translate-x-1/2 rounded-full bg-violet-600/20 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-2xl">
        {/* Cabecera */}
        <div className="flex flex-col items-center text-center">
          <img src={logoImg} alt="Karaoke Rooms Barcelona" className="w-56 sm:w-64" />
          <h1 className="mt-6 text-3xl font-bold uppercase tracking-wide text-white sm:text-4xl">Carta de bebidas</h1>
          <div className="mt-3 h-1 w-20 rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500" />
        </div>

        {/* Carta */}
        <div className="mt-10 rounded-3xl border border-white/10 bg-white/[0.04] p-6 shadow-2xl backdrop-blur-xl sm:p-10">
          {SECTIONS.map((section) => (
            <div key={section.title} className="mb-9 last:mb-0">
              <h2 className="mb-5 text-xs font-bold uppercase tracking-[0.25em] text-violet-300">{section.title}</h2>
              <ul className="space-y-4">
                {section.items.map((item) => (
                  <li key={item.name} className="flex items-baseline gap-3">
                    <div className="min-w-0">
                      <span className="text-base font-semibold uppercase text-white sm:text-lg">{item.name}</span>
                      {item.note && <span className="mt-0.5 block text-xs normal-case text-slate-400">{item.note}</span>}
                    </div>
                    <span className="-translate-y-1 flex-1 border-b border-dotted border-white/20" />
                    <span className="whitespace-nowrap text-base font-bold text-violet-200 sm:text-lg">{item.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 rounded-2xl border border-violet-500/20 bg-violet-500/10 p-6 text-center backdrop-blur-xl">
          <p className="text-lg font-bold uppercase tracking-wide text-white sm:text-2xl">
            ¡Pide desde tu móvil en la sala y te lo llevamos!
          </p>
        </div>
      </div>
    </div>
  );
};

export default CartaBebidas;
